import React from "react";
import ShareBar from "../../ShareBar";
import SignupForm from "../../SignupForm";

export function EndCta() {
  return (
    <div
      className="border-2 border-current p-8 md:p-12 mt-10"
      style={{ boxShadow: "8px 8px 0 0 hsl(var(--primary))" }}
      data-testid="reader-end-cta"
    >
      <div className="eyebrow mb-3">You've reached the field</div>
      <h3 className="font-display uppercase font-bold text-3xl md:text-5xl leading-[0.92] tracking-tight">
        You may be the Hundredth Monkey.
      </h3>
      <p className="font-body mt-6 text-lg leading-relaxed opacity-90 max-w-2xl">
        The book begs to be reproduced. Share it with one person.
        Then another. The field grows quietly until — suddenly — it doesn't.
      </p>
      <div className="mt-8">
        <ShareBar title="The Hundredth Monkey · Ken Keyes Jr." />
      </div>
      <div className="mt-10 border-t-2 border-current pt-8">
        <div className="eyebrow mb-3">Join NewWaysToday</div>
        <SignupForm />
      </div>
    </div>
  );
}

export function RightRail() {
  return (
    <aside
      className="hidden xl:block xl:sticky xl:top-24 xl:self-start"
      data-testid="reader-right-rail"
    >
      <div className="eyebrow mb-3">Share</div>
      <div className="space-y-3">
        <ShareBar variant="stacked" />
      </div>
      <div className="mt-10 border-2 border-current p-4">
        <div className="eyebrow mb-2">Quote of the page</div>
        <p className="font-serif-display italic text-lg leading-snug">
          "There is more power in numbers than we ever hoped to dream about."
        </p>
        <p className="eyebrow mt-3 opacity-70">— Ken Keyes, Jr.</p>
      </div>
    </aside>
  );
}
